import React, { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router';

import { EntityDeletedMessageContainer } from './EntityDeletedMessage.container';
import SubSystem from '../subscription/pages/systems/System';

import type { RootState } from '../types/state.types';

export const SystemDeletedContainer: React.FC<PropsWithChildren<RouteComponentProps<{}, any>>> = (
  props
) => {
  const { subId, systemID } = props.params;
  const deletedSystems = useSelector((state: RootState) => state.liveUpdates.deletedSystems);
  const isDeleted = deletedSystems.some((sId) => sId === systemID);
  const isDirty = useSelector((state: RootState) => state.editor.isDirty);
  const unsavedEditedConfig = useSelector((state: RootState) => state.editor.unsavedEditedConfig);

  if (isDeleted) {
    return (
      <EntityDeletedMessageContainer
        systemId={systemID}
        gotoLink={`/subscription/${subId}/systems/all`}
        config={isDirty ? unsavedEditedConfig : undefined}
        entityName="system"
      />
    );
  }

  return <SubSystem {...props} />;
};
